import type { Licence, OntologyStructuredData } from '@seek/ca-myprofile-utils';

import type * as Schema from 'src/types/graphql';

import type { GraphqlLicence, LicenceUpdateWithId } from './types';

export const mapAutosuggestToServer = ({
  text,
  ontologyId,
}: OntologyStructuredData): OntologyStructuredData => ({
  ...(ontologyId ? { ontologyId } : {}),
  text,
});

export const graphQLLicenceToUILicence = (
  licence: GraphqlLicence,
): Licence => ({
  id: licence.id,
  name: {
    text: licence.name.text,
    ontologyId: licence.name.ontologyId ?? undefined,
  },
  issuingOrganisation: licence.issuingOrganisation ?? undefined,
  issueDate: licence.issueDate ?? undefined,
  expiryDate: licence.expiryDate ?? undefined,
  noExpiryDate: licence.noExpiryDate,
  description: licence.description ?? undefined,
  credential: licence.credential ?? undefined,
  status: licence.status ?? undefined,
  formattedDate: licence.formattedDate ?? undefined,
  verificationUrl: licence.verificationUrl ?? undefined,
  verificationMessage: licence.verificationMessage ?? undefined,
  credentialType: licence.credentialType ?? undefined,
  isVerified: licence.isVerified ?? undefined,
});

export const licenceUpdateToUpdateLicenceInput = (
  licenceUpdate: LicenceUpdateWithId,
): Schema.UpdateLicenceInput => ({
  id: licenceUpdate.id,
  name: {
    text: licenceUpdate.name.text,
    ontologyId: licenceUpdate.name?.ontologyId || null,
  },
  issuingOrganisation: licenceUpdate?.issuingOrganisation || null,
  issueDate: licenceUpdate?.issueDate || null,
  expiryDate: licenceUpdate?.expiryDate || null,
  description: licenceUpdate?.description || null,
  noExpiryDate: licenceUpdate.noExpiryDate,
});
